import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { isFirstPartyUrl } from './protected-api-url';

const CORRELATION_HEADER = 'X-Correlation-Id';
const CORRELATION_STORAGE_KEY = 'gw-auth-correlation-id';

/**
 * Attaches a stable correlation id to brain API + brain-iam calls so GCP auth.flow lines
 * (and IAM CorrelationIdFilter) can join a browser login/MFA/OTP attempt end-to-end.
 *
 * WHERE it travels is the first-party scope of `protected-api-url.ts` (BRN-2325 L6 A-17): the
 * request's origin and path parsed and compared exactly, never a string prefix -- the same rule the
 * bearer follows -- with brain-iam's public sign-in routes deliberately inside the scope. The
 * payments API is outside it: its customer-route CORS allowlist admits `Authorization` and
 * `Content-Type` only, so this header would fail the preflight there.
 */
@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isFirstPartyUrl(request.url) || request.headers.has(CORRELATION_HEADER)) {
      return next.handle(request);
    }

    return next.handle(
      request.clone({
        setHeaders: {
          [CORRELATION_HEADER]: this.correlationId(),
        },
      }),
    );
  }

  private correlationId(): string {
    try {
      const existing = sessionStorage.getItem(CORRELATION_STORAGE_KEY);
      if (existing) {
        return existing;
      }
      const created = crypto.randomUUID();
      sessionStorage.setItem(CORRELATION_STORAGE_KEY, created);
      return created;
    } catch {
      return crypto.randomUUID();
    }
  }
}
